import * as Icons from '../assets/icons';

const useIcons = () =>
  Object.entries(Icons).map(([iconName, IconComponent]) => {
    const transformedName = transformIconName(iconName);
    return { [transformedName]: IconComponent };
  });

function transformIconName(iconName) {
  return iconName
    .replace('Icon', '')
    .replace(/([A-Z])/g, '_$1') // convert uppercase letters to underscores
    .toLowerCase() // convert to lowercase
    .slice(1); // remove initial dash;
}

export default useIcons;
